import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scroll-float-hint',
  templateUrl: './scroll-float-hint.component.html',
  styleUrls: ['./scroll-float-hint.component.scss'],
})
export class ScrollFloatHintComponent  implements OnInit {

  constructor() { }

  ngOnInit() {
    return;
  }

}
